import type { JSX } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';
import type { CreateCompanyFormData } from '../schemas/company.schemas';

const COMPANY_SIZES = [
  { value: 'SMALL', label: '1-50 employees' },
  { value: 'MEDIUM', label: '51-200 employees' },
  { value: 'LARGE', label: '201-1000 employees' },
  { value: 'ENTERPRISE', label: '1000+ employees' },
] as const;

function getSizeLabel(value: string | null | undefined): string | undefined {
  if (!value) return undefined;
  return COMPANY_SIZES.find((size) => size.value === value)?.label;
}

export interface CompanySizeSelectProps {
  value: string | null | undefined;
  onChange: (value: CreateCompanyFormData['companySize']) => void;
}

export function CompanySizeSelect({ value, onChange }: CompanySizeSelectProps): JSX.Element {
  const selectedLabel = getSizeLabel(value);

  return (
    <Select
      value={value || ''}
      onValueChange={(v) => onChange(v as CreateCompanyFormData['companySize'])}
    >
      <SelectTrigger id="companySize">
        {selectedLabel ? (
          <span className="truncate">{selectedLabel}</span>
        ) : (
          <span className="text-muted-foreground">Select size</span>
        )}
      </SelectTrigger>
      <SelectContent>
        {COMPANY_SIZES.map((size) => (
          <SelectItem key={size.value} value={size.value}>
            {size.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
